module.exports = "mutation UpdateStoreContact($data:UpdateStoreContactInput!){updateStoreContact(data:$data){success}}"